/*
  Appends the width to the image url to reduce the image size
*/
export const appendImageSize = (url: string, size: number = 100): string => {
  if (!url) return '';
  
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('width', size.toString());

    return urlObj.toString();
  } catch {
    return url;
  }
}; 